<template>
<!-- 为灵活信号设置页面提供修改信号的modal页面，根据信号的name展示不同的修改选项 -->
  <div>
    <Row>
      <Modal
        v-model="m_open_modal_switch"
        :title="this.get_modal_title()"
        :loading="loading_status"
        @on-ok="set_ok"
        @on-cancel="set_cancel"
        @on-visible-change="set_changed"
      >
        <p slot="header" class="demo-drawer-hearde">
          <Icon type="information-circled"></Icon>
          <span>{{ this.get_modal_title() }}</span>
        </p>
        <Row>
          <Col span="20" offset="2">
          <div v-if="this.m_type === 'sign' && this.name === 'ma'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="短MA参数">
                  <Slider
                    v-model="m_paras[0]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="长MA参数">
                  <Slider
                    v-model="m_paras[1]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="重采样参数">
                  <Select v-model="m_paras[2]" style="minwidth:200px">
                    <Option v-for="item in ma_interval[m_paras[3]]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="重采样频率">
                <Tooltip content="m=分钟, h=小时" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[3]" style="minwidth:200px" @on-change="m_or_h_change">
                    <Option v-for="item in [{value:'m',label:'m'}, {value:'h',label:'h'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[4]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效效率">
                  <Slider
                    v-model="m_execute_percent"
                    :step="0.01"
                    :max="1"
                    :min="0.01"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'ema'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="短EMA参数">
                  <Slider
                    v-model="m_paras[0]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="长EMA参数">
                  <Slider
                    v-model="m_paras[1]"
                    :step="1"
                    :max="1500"
                    :min="1"
                    show-input
                  ></Slider>
              </FormItem>
              <FormItem label="重采样参数">
                  <Select v-model="m_paras[2]" style="minwidth:200px">
                    <Option v-for="item in ma_interval[m_paras[3]]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="重采样频率">
                <Tooltip content="m=分钟, h=小时" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[3]" style="minwidth:200px" @on-change="m_or_h_change">
                    <Option v-for="item in [{value:'m',label:'m'}, {value:'h',label:'h'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[4]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效效率">
                  <Slider
                    v-model="m_execute_percent"
                    :step="0.01"
                    :max="1"
                    :min="0.01"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'price_judge'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="上穿/下穿">
                <Tooltip content="上穿(Up):标的价格>=设定价格即触发信号;下穿(Down):标的价格<=设定价格即触发信号" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[0]" style="minwidth:200px">
                    <Option v-for="item in [{value:'up',label:'Up'}, {value:'down',label:'Down'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="设定价格">
                  <InputNumber
                    v-model="m_paras[1]"
                    :min="0"
                  ></InputNumber>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[2]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效效率">
                  <Slider
                    v-model="m_execute_percent"
                    :step="0.01"
                    :max="1"
                    :min="0.01"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'sign_price_drop_judge'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="拉升触发/回落触发">
                <Tooltip content="拉升触发(Up)用于超跌反弹场景;回落触发(Down)用于冲高回落场景" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[0]" style="minwidth:200px">
                    <Option v-for="item in [{value:'up',label:'Up'}, {value:'down',label:'Down'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="拉升/回落临界幅度">
                <Tooltip content="拉升触发场景(Up):价格下跌刷新记录新低后回升, 回升现价/记录最低价-1>=临界幅度，即触发信号;回落触发场景(Down):价格上涨刷新记录新高后回落, 取绝对值(回落现价/记录最高价-1)>=临界幅度，即触发信号" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <InputNumber
                    v-model="m_paras[1]"
                    :max="1"
                  ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[2]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                  </Select>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效效率">
                  <Slider
                    v-model="m_execute_percent"
                    :step="0.01"
                    :max="1"
                    :min="0.01"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'sign' && this.name === 'trigger_immediately'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="信号值">
                <Tooltip content="表示达到信号触发的条件后,发出做多还是做空的方向" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <Select v-model="m_paras[0]">
                    <Option v-for="item in [{value:'buy',label:'Buy'}, {value:'sell',label:'Sell'}]" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </Tooltip>
              </FormItem>
              <FormItem label="信号生效效率">
                  <Slider
                    v-model="m_execute_percent"
                    :step="0.01"
                    :max="1"
                    :min="0.01"
                    show-input
                    :disabled="this.open_or_close === 'open'"
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'default' && this.name === 'stop_loss'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="止损百分比">
                <Tooltip content="格式形如:0.03,表示基于成本价3%不利幅度即止损" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <InputNumber
                      v-model="m_paras[0]"
                      :max="0.5"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="推止损百分比">
                <Tooltip content="在做多时，-0.03表示不高于成本价-3%的推止损幅度;0.03表示不高于成本价3%的推止损幅度。做空以此类推" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <InputNumber
                      v-model="m_paras[1]"
                      :max="0.5"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效效率">
                  <Slider
                    v-model="m_execute_percent"
                    :step="0.01"
                    :max="1"
                    :min="0.01"
                    show-input
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'default' && this.name === 'stop_gain'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="止盈百分比">
                <Tooltip content="0.03,表示基于成本价达到3%的有利幅度即止盈" :delay="this.m_tooltip_delay" :max-width="this.m_tooltip_max_width">
                  <InputNumber
                      v-model="m_paras[0]"
                      :max="10"
                    ></InputNumber>
                </Tooltip>
              </FormItem>
              <FormItem label="信号生效效率">
                  <Slider
                    v-model="m_execute_percent"
                    :step="0.01"
                    :max="1"
                    :min="0.01"
                    show-input
                  ></Slider>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'function_type'">
            <Form label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="订单执行方式">
                <Select v-model="m_paras[0]">
                  <Option v-for="item in this.function_type_index_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'strategy_msg'">
            <Form label-position="left" :label-width="140" :label-colon="true" ref="strategy_msg_validate" :model="m_paras" :rules="strategy_msg_form_rules">
              <FormItem label="执行标的">
                <Select v-model="m_paras['current_symbol']" filterable :disabled="m_paras['create_or_alter_table_disabled']">
                  <Option v-for="item in get_strategy_list()" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="策略名" prop="name">
                  <Input
                    v-model="m_paras.name"
                    clearable
                  ></Input>
              </FormItem>
              <FormItem label="策略描述信息" prop="description">
                  <Input
                    v-model="m_paras.description"
                    clearable
                    type="textarea"
                  ></Input>
              </FormItem>
              <FormItem label="绑定账户数量" prop="acc_count">
                  <InputNumber
                    v-model="m_paras['acc_count']"
                    readonly
                  ></InputNumber>
              </FormItem>
              <FormItem label="运行次数">
                  <InputNumber
                    v-model="m_paras['run_count']"
                    readonly
                  ></InputNumber>
              </FormItem>
              <FormItem label="上次更新时间">
                  <Input
                    v-model="m_paras['last_update_datetime']"
                    readonly
                  ></Input>
              </FormItem>
            </Form>
          </div>
          <div v-else-if="this.m_type === 'select_strategy_msg'">
            <Form ref="select_strategy_ref" label-position="left" :label-width="140" :label-colon="true">
              <FormItem label="策略ID">
                <Select v-model="select_strategy_id" filterable>
                  <Option v-for="item in get_select_strategy_list()" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
              </FormItem>
              <FormItem label="策略名" v-if="select_strategy_id != -1">
                <Input
                  v-model="select_strategy['strategy_name']"
                  readonly
                  placeholder="请输入策略名.."
                ></Input>
              </FormItem>
              <FormItem label="策略描述信息"  v-if="select_strategy_id != -1">
                  <Input
                    v-model="select_strategy['description']"
                    readonly
                    placeholder="请输入策略描述信息.."
                    type="textarea"
                  ></Input>
              </FormItem>
              <FormItem label="策略当前运行状态" v-if="select_strategy_id != -1">
                  <Input
                    v-model="select_strategy_status_code_index[select_strategy['current_status_code'].toString()]"
                    readonly
                  ></Input>
              </FormItem>
              <FormItem label="运行次数" v-if="select_strategy_id != -1">
                  <InputNumber
                    v-model="select_strategy['run_count']"
                    readonly
                  ></InputNumber>
              </FormItem>
              <FormItem label="上次更新时间" v-if="select_strategy_id != -1">
                  <Input
                    v-model="select_strategy['last_update_datetime']"
                    readonly
                  ></Input>
              </FormItem>
            </Form>
          </div>
          <div v-else>
          </div>
          </Col>
        </Row>
      </Modal>
    </Row>
  </div>
</template>
<script>
import store from '../../store'

export default {
  name: "flexible_render_modal_view",
  data() {
    return {
      //["1m", "3m", "5m", "15m", "30m", "1h", "2h", "4h", "6h", "8h", "12h"]
      ma_interval:{
        "m":[
          {value: 1,label: '1'},
          {value: 3,label: '3'},
          {value: 5,label: '5'},
          {value: 15,label: '15'},
          {value: 30,label: '30'},
        ],
        "h":[
          {value: 1,label: '1'},
          {value: 2,label: '2'},
          {value: 4,label: '4'},
          {value: 6,label: '6'},
          {value: 8,label: '8'},
          {value: 12,label: '12'},
        ]
      },
      function_type_index_list: [],
      select_strategy_status_code_index: {
        "0":'待启动',
        "1":'正在运行',
        "2":'历史策略',
        "-1":'',
      },
      m_paras:null,
      m_name:"",
      m_type:"",
      m_execute_percent:1,
      m_open_modal_switch:false,

      //信号、止盈止损等输入框体的提示
      m_tooltip_delay:500,
      m_tooltip_max_width:200,
      
      //当用户在选择录入的ID时, 所有状态使用该object控制
      select_strategy_id:null,
      select_strategy:{
        "current_status_code":'-1',
        "current_symbol":null,
        "run_count":null,
        "strategy_name":null,
        "last_update_datetime":null,
        "description":null,
      },
      loading_status:true,
      strategy_msg_form_rules:{
        name: [
            { required: true, message: '策略名不能为空', trigger: 'blur' }
        ],
        description: [
            { required: true, message: '描述信息不能为空', trigger: 'blur'}
        ],
        acc_count: [
          { required: true, message: '至少绑定一个账户', trigger: 'blur', type:"number", min:1}
        ]
      }
    }
  },
  props: {
    paras: {
      type: [Array, Object],
    },
    open_modal_switch:{
      type: Boolean,
      default: false
    },
    uuid: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    modal_type: {
      type: String,
      default: ""
    },
    open_or_close: {
      type: String,
      validator: function(value) {
        return ["open", "close"].indexOf(value) != -1
      }
    },
    execute_percent: {
      type: Number,
      default: 1.0,
      validator: function(value) {
        if (value > 0 && value <=1 ) {
          return true
        } else {
          return false
        }
      }
    }
  },
  methods:{
    get_strategy_list() {
      // 在用户单击了确认修改的按钮时，返回可选的所有symbol列表
      let strategy_msg_index_list = []
      for (var i = 0; i < this.paras["symbol_list"].length; i++) {
        strategy_msg_index_list.push({
          "value":this.paras["symbol_list"][i],
          "label":this.paras["symbol_list"][i],
        })
      }
      return strategy_msg_index_list
    },
    get_select_strategy_list() {
      let strategy_list = []
      // 根据后台的数据，展示所有可以被选择的策略ID
      for (var key in this.m_paras) {
        key = key.toString()
        if (key != "-1") {
          strategy_list.push({
            "value":key,
            "label":key+"号",
          })
        } else {
          strategy_list.push({
            "value":key,
            "label":"创建新策略",
          })
        }
      }
      return strategy_list
    },
    get_modal_title() {
      if (this.m_type === 'strategy_msg' && this.uuid.toString() === "-1") {
        return "提交新策略参数"
      } else if (this.m_type === 'strategy_msg' && this.uuid.toString() != "-1") {
        return "设置" + this.uuid + "号策略的参数"
      } else if (this.m_type === 'select_strategy_msg') {
        return "选择策略，修改参数"
      } else {
        return "设置" + this.uuid + "号策略的参数"
      }
    },
    set_ok_for_type_strategy_msg() {
      this.$refs["strategy_msg_validate"].validate((valid) => {
          if (valid) {
            this.loading_status = true
            this.$emit("modal_click", {
              "paras":this.m_paras,
              "name":this.m_name,
              "uuid":this.uuid,
              "execute_percent":this.m_execute_percent,
              "m_type":this.m_type,
              "mode":"ok",
            })
          } else {
            setTimeout(() => {
              this.loading_status = false;
              this.$nextTick(()=>{
                this.loading_status = true;
              })
            }, 200);
          }
          return null
      }, (error) => {
        console.log("检验函数遇到错误")
        console.log(error)
      })
    },
    set_ok() {
      if (this.m_type === "select_strategy_msg") {
        this.select_strategy["id"] = this.select_strategy_id
        this.$emit("modal_click", {
          "paras":this.m_paras,
          "uuid":this.uuid,
          "execute_percent":this.m_execute_percent,
          "m_type":this.m_type,
          "select_strategy":this.select_strategy,
          "mode":"ok",
        })
      } else if (this.m_type === "strategy_msg") {
        this.set_ok_for_type_strategy_msg()
      } else {
        this.$emit("modal_click", {
          "paras":this.m_paras,
          "name":this.m_name,
          "uuid":this.uuid,
          "execute_percent":this.m_execute_percent,
          "m_type":this.m_type,
          "mode":"ok",
        })
      }
    },
    set_cancel() {
      this.$emit("modal_click", {
        "mode":"cancel",
      })
    },
    set_changed(value) {
      if (value == false) {
        setTimeout(() => {
          this.m_type = ""
        }, 250);
      }
    },
    m_or_h_change() {
      this.paras[2] = 1
    },
  },
  mounted: function() {
    var function_type_index = store.state.function_type_index
    this.function_type_index_list = []
    for (var key in function_type_index ) {
      this.function_type_index_list.push({
        value:Number(key), label:function_type_index[key]
      })
    }
  },
  watch: {
    open_modal_switch(old_value) {
      // 避免直接由内部修改props的情况
      this.m_open_modal_switch = this.open_modal_switch
      if (this.m_open_modal_switch == true) {
        // 在打开modal的时候初始化参数
        this.m_paras = JSON.parse(JSON.stringify(this.paras))
        this.m_name = this.name
        this.m_type = this.modal_type
        this.m_execute_percent = this.execute_percent
        if (this.m_type === "select_strategy_msg" || this.m_type === "strategy_msg") {
          // 在选择导入的ID时，需要初始化前端的输入
          this.select_strategy_id = this.uuid
        }
      } else {

      }
    },
    select_strategy_id(old_value) {
      if (this.select_strategy_id.toString() != "-1") {
        let select_con = null
        // 当选择id改变，需要同时改变其他显示信息
        for (var i = 0; i < this.m_paras[this.select_strategy_id].length; i++) {
          if (this.m_paras[this.select_strategy_id][i]["type"] === "strategy_msg") {
            select_con = this.m_paras[this.select_strategy_id][i]
            break
          }
        }
        if (select_con === null) {
          console.log("wrong select_strategy_id")
          return null
        }
        this.select_strategy["current_status_code"] = select_con["paras"]["current_status_code"]
        this.select_strategy["current_symbol"] = select_con["paras"]["current_symbol"]
        this.select_strategy["run_count"] = select_con["paras"]["run_count"]
        this.select_strategy["strategy_name"] = select_con["paras"]["name"]
        this.select_strategy["last_update_datetime"] = select_con["paras"]["last_update_datetime"]
        this.select_strategy["description"] = select_con["paras"]["description"]
      } else {
        this.select_strategy["current_status_code"] = '-1'
        this.select_strategy["current_symbol"] = ""
        this.select_strategy["run_count"] = 0
        this.select_strategy["strategy_name"] = null
        this.select_strategy["last_update_datetime"] = null
        this.select_strategy["description"] = null
      }
    }
  }
}
</script>
<style>
.demo {
  font-size: 10px;
  border: 0px none transparent;
  background-color:transparent;
}
</style>